module.exports = __webpack_public_path__ + "img/AgeUpIcon3Active_ua.13daac02.webp";